import { renderToStaticMarkup } from "react-dom/server";
import { QRCodeSVG } from "qrcode.react";
import { printHtml } from "@/printer";
import { GUIDE_TITLES, guideTitle } from "@/helpGuides";

const esc = (s) => String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;");

const card = (key, lang, hint) => {
  const url = `${window.location.origin}/guida/${key}?lang=${lang}`;
  const qr = renderToStaticMarkup(<QRCodeSVG value={url} size={150} />);
  return `
  <div class="qrcard">
    <div class="brand">CHEF CONTROL</div>
    <div class="ttl">${esc(guideTitle(key, lang))}</div>
    ${qr}
    <div class="hint">${esc(hint)}</div>
  </div>`;
};

const CSS = `
  body{font-family:Helvetica,Arial,sans-serif;margin:0;padding:10mm;color:#0d1f3d}
  .qrcard{border:2.5px solid #0d1f3d;border-radius:14px;padding:8mm 6mm;text-align:center;width:62mm;
    display:inline-block;vertical-align:top;margin:3mm;page-break-inside:avoid}
  .brand{font-size:9px;letter-spacing:3px;color:#a8853f;font-weight:bold;margin-bottom:2mm}
  .ttl{font-size:15px;font-weight:bold;margin-bottom:3mm}
  .hint{font-size:9px;color:#555;margin-top:3mm;line-height:1.35}
`;

// Stampa il QR della schermata corrente (cartellino da attaccare alla postazione)
export function printStationQR(key, lang, hint) {
  printHtml(`<html><head><style>${CSS} body{display:flex;justify-content:center;padding-top:20mm}</style></head><body>${card(key, lang, hint)}</body></html>`);
}

// Stampa il foglio con i QR di TUTTE le schermate (uno per postazione)
export function printAllStationQRs(lang, hint) {
  const cards = Object.keys(GUIDE_TITLES).map((k) => card(k, lang, hint)).join("");
  printHtml(`<html><head><style>${CSS}</style></head><body>${cards}</body></html>`);
}
